import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroBanners } from '@/mocks/homeData';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = heroBanners.length;

  const goTo = useCallback((index: number) => {
    setCurrent(index);
  }, []);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const heroImages = [
    'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20at%20dusk%20with%20warm%20golden%20lanterns%20lighting%20the%20courtyard%2C%20cinematic%20atmosphere%20with%20misty%20mountains%20in%20background%2C%20rich%20amber%20and%20dark%20brown%20color%20palette%2C%20epic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20high%20contrast%2C%20artistic%20illustration%20with%20traditional%20Chinese%20architectural%20elements%20and%20flowing%20silk%20textures&width=1600&height=900&seq=hero-banner-01&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Colorful%20modern%20variety%20show%20stage%20with%20vibrant%20warm%20stage%20lights%20in%20amber%20and%20coral%20tones%2C%20energetic%20entertainment%20atmosphere%2C%20abstract%20geometric%20stage%20design%20with%20dynamic%20light%20beams%2C%20artistic%20illustration%20style%2C%20warm%20gradient%20background%2C%20festive%20and%20exciting%20mood&width=1600&height=900&seq=hero-banner-02&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Warm%20cozy%20traditional%20Chinese%20kitchen%20scene%20with%20steaming%20food%20on%20wooden%20table%2C%20soft%20golden%20natural%20light%20streaming%20through%20window%2C%20rich%20earthy%20warm%20tones%2C%20artistic%20documentary%20film%20style%2C%20shallow%20depth%20of%20field%2C%20intimate%20atmosphere%20with%20gentle%20steam%20and%20textured%20surfaces&width=1600&height=900&seq=hero-banner-03&orientation=landscape',
  ];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="精选推荐横幅">
      {/* Background Images */}
      {heroImages.map((src, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={src}
            alt={heroBanners[index].subtitle}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      {/* Content */}
      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl">
            {/* Badge */}
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500 text-white mb-4">
              {heroBanners[current].badge}
            </span>

            {/* Subtitle */}
            <p className="text-sm md:text-base text-white/80 mb-2 font-medium tracking-wide">
              {heroBanners[current].title}
            </p>

            {/* Main Title */}
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4 leading-tight">
              {heroBanners[current].subtitle}
            </h1>

            {/* Description */}
            <p className="text-sm md:text-base text-white/70 max-w-lg mb-6 leading-relaxed">
              {heroBanners[current].description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/all"
                className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill mr-2 text-lg"></i>
                立即观看
              </Link>
              <Link
                to="/vip"
                className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-white/15 hover:bg-white/25 text-white text-sm font-medium backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer border border-white/20"
              >
                <i className="ri-vip-crown-line mr-2 text-lg"></i>
                开通会员
              </Link>
            </div>

            {/* Indicators */}
            <div className="flex gap-2 mt-8">
              {heroBanners.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goTo(index)}
                  className={`h-1 rounded-full transition-all duration-300 cursor-pointer ${
                    index === current
                      ? 'w-8 bg-primary-500'
                      : 'w-2 bg-white/40 hover:bg-white/60'
                  }`}
                  aria-label={`切换到第${index + 1}张`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}